export default __webpack_public_path__ + "static/media/logo-white.4ece8c6e.png";